import { render, staticRenderFns } from "./RichTextImage.vue?vue&type=template&id=3337db24&scoped=true&"
import script from "./RichTextImage.vue?vue&type=script&lang=js&"
export * from "./RichTextImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3337db24",
  null
  
)

export default component.exports